import { fetcher } from "@weezevent/weezjs-core";
import linkParser from "parse-link-header";

/**
 * Pack the response from the API to a more usable object for infinite scroll
 * @param response
 * @returns {{data, link: *, totalCount: *}}
 */
export const packResponse = (response, dataField = "data") => ({
	data: response[dataField],
	link: response.headers.get("link"),
	totalCount: response.headers.get("total-count")
});

/**
 * Pack the response from the API with the help of link Parser (use for limit offset pagination)
 * @param response
 * @returns {{data, link: *, totalCount: *}}
 */
export const packResponseLinkParser = function(
	response,
	dataField = "response"
) {
	const linkData = linkParser(response.headers.get("Link"));
	return {
		data: response[dataField],
		link: linkData?.next?.url,
		totalCount: response.headers.get("total-count")
	};
};

/**
 * Get some data by link
 * @param link - url to the data
 * @returns {Promise<*>}
 */
export const getByLink = link => {
	return fetcher
		.get(link, { endpoint: window.weezConfig.api.apiUrl })
		.then(v => packResponse(v, "response"));
};
